export var PALETTE = {
    HEADER: "#121212",
    HEADERTEXT: "#B22222",
    NAV: "#003366",
    NAVBOTTOMBOTTOM: "#B22222",
    DIVIDER: "#7C1717",
    CONTENTAREA: "rgba(186, 186, 186, .6)",
    CONTENTAREATEXT: "#000",
    TABS: "#555",
    PAPER: "#ccc",
    HIGHLIGHT: "#B22222",
    ACCENT: "#FF4100",
    FOOTER: "#121212",
    FOOTERTEXT: "#B22222"
};
export var backgroundImage = "radial-gradient(gray 0.5px, transparent 0.5px)";
export var backgroundSize = "15px 15px";
